/**
 *  Étkezés napi ára – EGY helyen.
 *
 *  A rendelés a menü alapján megy: a menü hordozza az árat és a beszállítót is
 *  (a diétás igény külön menü, ezért nincs laktóz/glutén felár). A diák
 *  kedvezménye (`etkezes_szazalek`) ezen felül érvényesül.
 *
 *  Azért közös függvény, mert ugyanezt a képletet használja a havi kiírás
 *  (pénzügy → egyenleg), a tömeges ebédkiírás és a könyvelési előkészítő is –
 *  ha külön-külön másolódna, előbb-utóbb elcsúsznának egymástól.
 */

export interface EtkezesNap {
  value?: any;
  tranzakcio?: any;
  menu?: string | null;
}

/** A diák számára ismert összes menü (minden beszállítótól). */
export function osszesMenu(tanulo: any): any[] {
  const beszallitoktol = (tanulo?.beszallitok || [])
    .reduce((acc: any[], b: any) => acc.concat(b.menuk || []), []);
  return beszallitoktol.length ? beszallitoktol : (tanulo?.menuk || []);
}

/** Egy megrendelt nap ára. Ha a naphoz nincs menü (régi adat), az étkezőhely alapára. */
export function etkezesNapiAr(tanulo: any, nap: EtkezesNap): number {
  const menu = osszesMenu(tanulo).find((m: any) => m.id == nap?.menu);
  const ar = menu ? Number(menu.ar) : Number(tanulo?.etkezes_hely_adatok?.ar || 0);
  const kedvezmeny = Number(tanulo?.etkezes_szazalek || 0);
  return (ar || 0) * (100 - kedvezmeny) / 100;
}

/**
 *  Egy hónap fizetendő étkezése egy diákra: a még ki nem számlázott (tranzakcio=0),
 *  megrendelt napok összege. A régi `tanulo.etkezes` kapcsolót szándékosan NEM
 *  nézzük: a nap megrendelése maga a bizonyíték, hogy az étkezés kért.
 */
export function etkezesHaviOsszeg(tanulo: any): number {
  return etkezesIdoszakOsszeg(tanulo, null, null);
}

/**
 *  Ugyanez a hónap egy RÉSZÉRE (kétheti / félhavi számlázás): csak a `napTol`–`napIg`
 *  közé eső napok. A napok 1-től számozódnak, ahogy a naptár – az `adatok` tömb
 *  viszont 0-tól, ezért a `napTol - 1` eltolás.
 *
 *  Üres tartomány = teljes hónap, így a havi kiírás számítása bitre ugyanaz marad.
 */
export function etkezesIdoszakOsszeg(
  tanulo: any, napTol: number | null | undefined, napIg: number | null | undefined,
): number {
  const napok: EtkezesNap[] = tanulo?.adatok || [];
  const tol = Number(napTol) >= 1 ? Math.trunc(Number(napTol)) : 1;
  const ig = Number(napIg) >= 1 ? Math.trunc(Number(napIg)) : napok.length;
  return napok.reduce((sum: number, d: EtkezesNap, i: number) => {
    const nap = i + 1;
    if (nap < tol || nap > ig) return sum;
    return d?.value == 1 && d?.tranzakcio == 0 ? sum + etkezesNapiAr(tanulo, d) : sum;
  }, 0);
}
